module.exports = __webpack_public_path__ + "img/w3_exclamation_grey.4796374b.png";